export default __webpack_public_path__ + "static/person-33ce6490addc554aa975bda0be75f8ce.jpg";